/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Invite_InvalidInputs */

const en_community_invite_invalid = /** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invite link is invalid or has expired.`)
};

const id_community_invite_invalid = /** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan undangan ini tidak valid atau telah kedaluwarsa.`)
};

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const es_community_invite_invalid = en_community_invite_invalid;

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const fr_community_invite_invalid = en_community_invite_invalid;

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const de_community_invite_invalid = en_community_invite_invalid;

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const ja_community_invite_invalid = en_community_invite_invalid;

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const zh_community_invite_invalid = en_community_invite_invalid;

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const ar_community_invite_invalid = en_community_invite_invalid;

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const it_community_invite_invalid = en_community_invite_invalid;

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const ru_community_invite_invalid = en_community_invite_invalid;

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const pt_community_invite_invalid = en_community_invite_invalid;

/** @type {(inputs: Community_Invite_InvalidInputs) => LocalizedString} */
const ko_community_invite_invalid = en_community_invite_invalid;

/**
* | output |
* | --- |
* | "This invite link is invalid or has expired." |
*
* @param {Community_Invite_InvalidInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_invite_invalid = /** @type {((inputs?: Community_Invite_InvalidInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Invite_InvalidInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_invite_invalid(inputs)
	if (locale === "es") return es_community_invite_invalid(inputs)
	if (locale === "fr") return fr_community_invite_invalid(inputs)
	if (locale === "de") return de_community_invite_invalid(inputs)
	if (locale === "ja") return ja_community_invite_invalid(inputs)
	if (locale === "zh") return zh_community_invite_invalid(inputs)
	if (locale === "ar") return ar_community_invite_invalid(inputs)
	if (locale === "id") return id_community_invite_invalid(inputs)
	if (locale === "it") return it_community_invite_invalid(inputs)
	if (locale === "ru") return ru_community_invite_invalid(inputs)
	if (locale === "pt") return pt_community_invite_invalid(inputs)
	return ko_community_invite_invalid(inputs)
});